import styled from 'styled-components';
import { Flex } from 'components/base/layout-components';
import { getColor } from 'common/constants/_colors';
import Icon from 'components/base/Icon';
import React from 'react';

export const StyledInstructionsBox = styled(Flex)`
  position: relative;
  width: ${({ width }) => (width ? width : '25rem')};
  height: fit-content;
  border-radius: 0.45rem;
  background: white;
  padding: 0.8rem;
  ${({ isInfo }) =>
    isInfo
      ? 'box-shadow: 0px 0px 34px rgba(59, 89, 152, 0.2);'
      : 'border: 1px solid #cdc1ff;'}
`;

export const StyledDash = styled.div`
  position: absolute;
  ${({ top }) => (top ? `top: ${top};` : '')}
  ${({ bottom }) => (bottom ? `bottom: ${bottom};` : '')}
  ${({ left }) => (left ? `left: ${left};` : '')}
  ${({ right }) => (right ? `right: ${right};` : '')}
  ${({ width, bottomDash }) =>
    width
      ? `border-${bottomDash ? 'bottom' : 'top'}: 1px dashed;
         width: ${width};`
      : ''}
  ${({ height }) =>
    height
      ? `border-left: 1px dashed;
         height: ${height};`
      : ''}
  border-color: ${getColor('shuttleGray')};
`;
export const StyledDot = styled.div`
  position: absolute;
  ${({ top }) => (top ? `top: ${top};` : '')}
  ${({ bottom }) => (bottom ? `bottom: ${bottom};` : '')}
  ${({ left }) => (left ? `left: ${left};` : '')}
  ${({ right }) => (right ? `right: ${right};` : '')}
  height: 0.5rem;
  width: 0.5rem;
  background: ${getColor('shuttleGray')};
  border-radius: 0.5rem;
`;

export const InfoInstructionsBox = ({ children }) => (
  <StyledInstructionsBox isInfo gap='0.6rem' items='center'>
    <Flex self='flex-start'>
      <Icon name='erroricon' color='orangePeel' size='medium' />
    </Flex>
    {children}
  </StyledInstructionsBox>
);
